<script>
import ModelDetails from "../../components/drawings/drawing-details";
import Loader from "../../components/loader";

import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {ModelDetails, Loader},
  props: {
    resource: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      singleImage: false,
      selectedPerson: null,
      localModel: null,
      loading: false,
      inventory: this.resource
    };
  },
  methods: {
    async loadInventory() {
      this.loading = true;
      return await api.get(
          "drawings",
          {
            id: this.inventory.id,
            with: 'exhibition,sleeve,authors,persons,sets,technics,types,numerisations'
          }
      )
          .then((response) => {
            this.localModel = response.data
          })
          .finally(() => {
            this.loading = false;
          });
    }
  },
  created() {
    this.localModel = this.loadInventory();
  }
};
</script>

<template>
  <Loader :loading="loading">
    <b-card no-body>
      <b-card-body>
        <h5>{{ localModel.exploitation_number }} <span class="badge badge-soft-info">{{ localModel.inventory_number }}</span></h5>
        <h5>{{ localModel.title }}</h5>

        <ul class="list-inline">
          <li class="list-inline-item me-3" v-if="localModel.authors && localModel.authors.length !== 0"><i
              class='bx bx-camera'></i>
            <div
                class="d-inline text-capitalize "
                v-for="(person, key) in localModel.authors"
                :key="person.id"
                v-b-modal.inventory-details-modal-person
                @click="selectedPerson = person"
            >
              {{ person.last_name }}, {{ person.first_name }}
              <span v-if="key < (localModel.authors.length - 1)">; </span>
            </div>
          </li>
          <li class="list-inline-item me-3" v-if="localModel.persons && localModel.persons.length !== 0"><i
              class='bx bx-group'></i>
            <div
                class="d-inline"
                v-for="(person, key) in localModel.persons"
                :key="person.id"
                v-b-modal.inventory-details-modal-person
                @click="selectedPerson = person"
            >
              {{ person.last_name }}, {{ person.first_name }}
              <span v-if="key < (localModel.persons.length - 1)">; </span>
            </div>
          </li>
          <li class="list-inline-item me-3"><i class='bx bx-calendar'></i> <span
              v-html="localModel.date"></span>
          </li>

          <li class="list-inline-item me-3" v-if="localModel.format"><i class='bx bx-ruler'></i>
            {{ localModel.format }}
          </li>
        </ul>

        <b-card-text v-if="localModel.caption">
          <h6>Titre</h6>
          <blockquote class="blockquote">
            {{ localModel.caption }}
          </blockquote>
        </b-card-text>

        <b-card-text v-if="localModel.annotations">
          <h6>Annotations</h6>
          <blockquote class="blockquote">
            {{ localModel.annotations }}
          </blockquote>
        </b-card-text>

        <b-card-text v-if="localModel.state">
          <h6>Constat d'état</h6>
          <blockquote class="blockquote">
            {{ localModel.state }}
          </blockquote>
        </b-card-text>

        <b-card-text v-if="localModel.comment">
          <h6>Commentaire</h6>
          <blockquote class="blockquote">
            {{ localModel.comment }}
          </blockquote>
        </b-card-text>

        <b-card-text v-if="localModel.exhibition">
          <h6>Exposition</h6>
          <blockquote class="blockquote">
            {{ localModel.exhibition.name }}
          </blockquote>
        </b-card-text>
      </b-card-body>

      <b-modal id="inventory-details-modal-person" centered hide-footer
               size="md"
               title-class="font-18"
               @hide="selectedPerson = null">
        <model-details v-if="selectedPerson" :person="this.selectedPerson"></model-details>
      </b-modal>
    </b-card>
  </Loader>
</template>
